import { render, staticRenderFns } from "./emailForm.vue?vue&type=template&id=9bb3f156&scoped=true"
import script from "./emailForm.vue?vue&type=script&lang=js"
export * from "./emailForm.vue?vue&type=script&lang=js"
import style0 from "./emailForm.vue?vue&type=style&index=0&id=9bb3f156&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb3f156",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bb3f156')) {
      api.createRecord('9bb3f156', component.options)
    } else {
      api.reload('9bb3f156', component.options)
    }
    module.hot.accept("./emailForm.vue?vue&type=template&id=9bb3f156&scoped=true", function () {
      api.rerender('9bb3f156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notify/systemScene/components/emailForm.vue"
export default component.exports